import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/index.vue";
import Home from "../components/Home.vue";
import openMore from "../views/controlModules/openMore.vue";
import AIdetail from "../views/AIdetail/index.vue";
import Controlindex from "@/views/control.vue";
import AlertDetail from "@/views/WarningCenter/AlertDetail.vue";
import WarningHistory from "../views/WarningCenter/WarningHistory/index.vue";
import IoTDevices from "../views/DeviceCenter/pointcenter.vue";
import ParameterSetting from "../views/ParameterSetting/index.vue";

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: "/ai/control" },
  {
    path: "/home",
    component: Home,
    children: [
      { path: "/ai/control", component: Controlindex },
      { path: "/openMore", component: openMore },
      {
        path: "/ai/detail",
        component: AIdetail,
        meta: { active: "/ai/control" },
      },
      {
        path: "/alertDetail",
        component: AlertDetail,
        meta: {
          active: "/warningCenter",
        },
      },
      { path: "/warningCenter", component: WarningHistory },
      { path: "/IoTDevices", component: IoTDevices },
      { path: "/parameterSetting", component: ParameterSetting },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  // caseSensitive: true,
  routes,
});

// router.beforeEach((to, from, next) => {
//   if (to.query.id) {
//     // this.$store.commit("changeid", to.query.id);
//     window.sessionStorage.setItem("waringid", to.query.id);
//   }
//   console.log(to);
//   if (to.path === "/login") return next();
//   const tokenStr = window.sessionStorage.getItem("access_token");
//   if (!tokenStr) return next("/login");
//   next();

//   if (to.path === "/parameterSetting" || to.path === "/parametersetting") {
//     console.log(123213213213213213);
//     var loginStr = window.sessionStorage.getItem("loginIndex1");
//     console.log(typeof loginStr);
//     console.log(loginStr);
//     if (loginStr === "0") {
//       next();
//       console.log(666);
//     } else {
//       console.log(888);
//       next({
//         path: "/parameterLogin",
//       });
//     }
//   }
//   // if (to.path === "/parameterSetting") {
//   //   const loginStr = window.sessionStorage.getItem("loginIndex1");
//   //   console.log(loginStr);
//   //   if (loginStr === 1) {
//   //     console.log(34);
//   //     next();
//   //   } else {
//   //     console.log(56);
//   //     next({
//   //       path: "/parameterLogin",
//   //     });
//   //   }
//   // }
// });

export default router;
